import { useEffect, useRef, useState } from 'react'
import DesignTab from 'views/TrackView/tabs/DesignTab'
import { useWaveformQuery } from 'api/api'
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg'
import { ReactComponent as PrevIcon } from 'assets/icons/chev-prev.svg'
import WaveformCanvasExample from 'components/WaveformPlayer/WaveformCanvasExample'
import ColorInput from '../ColorInput/ColorInput'
import { cloneDeep } from 'lodash'

const PlaylistEditorTrackThemeModal = ({
  track,
  initialValues,
  onSubmit,
  onRemove,
  onRequestClose,
}) => {
  const containerRef = useRef()

  const { data: waveformData, isFetching: waveformDataLoading } =
    useWaveformQuery(process.env.REACT_APP_EXAMPLE_WAVEFORM)
  const [values, setValues] = useState(initialValues)
  const isNew = initialValues?.newTheme

  function handleSubmit() {
    const valuesToSubmit = {
      bgColor: values.bgColor,
      fgColor: values.fgColor,
      highlightColor: values.highlightColor,
    }

    onSubmit(valuesToSubmit)
  }

  const { highlightColor, bgColor, fgColor } = values || {}

  function handleThemeChange(name, value) {
    const newValues = cloneDeep(values)
    newValues[name] = value
    setValues(newValues)
  }

  return (
    <div className="h-full flex flex-col bg-gray relative" ref={containerRef}>
      <div className="">
        <div className="px-6 py-6 bg-gray-light">
          <button
            onClick={() => onRequestClose()}
            className="flex items-center justify-between mb-2"
          >
            <PrevIcon fill="#ccc" />{' '}
            <span className="block ml-2 text-sm">Back</span>
          </button>
          <h2 className="">Override {track.text} Theme</h2>
        </div>
      </div>
      <div className="py-10 px-6 relative">
        <WaveformCanvasExample
          waveformData={waveformData?.drawableData}
          theme={values}
        />
      </div>

      <div className="px-8 pb-6 flex-1">
        <div className="h-full w-full">
          <h3 className="mb-2">Theme</h3>
          <div className="flex">
            <div className="w-full max-w-[200px]">
              <ColorInput
                label="Primary Color"
                value={highlightColor}
                containerRef={containerRef}
                onChange={(value) => handleThemeChange('highlightColor', value)}
              />
            </div>
            <div className="w-full max-w-[200px] ml-10">
              <ColorInput
                label="Secondary Color"
                value={fgColor}
                containerRef={containerRef}
                onChange={(value) => handleThemeChange('fgColor', value)}
              />
            </div>
            <div className="w-full max-w-[200px] ml-10">
              <ColorInput
                label="Background Color"
                value={bgColor}
                containerRef={containerRef}
                onChange={(value) => handleThemeChange('bgColor', value)}
              />
            </div>
          </div>
          <div className=" mt-10 mb-6">
            {!isNew && (
              <button
                className="button bg-gray-dark hover:bg-deep mr-6"
                onClick={onRemove}
              >
                Remove Override
              </button>
            )}
            <button
              className="button bg-pink hover:bg-pink-off"
              onClick={handleSubmit}
            >
              Save
            </button>
          </div>
        </div>
      </div>

      <div className="absolute right-1 top-1">
        <button
          className="button icon bg-transparent  text-white-dark"
          onClick={onRequestClose}
        >
          <CloseIcon fill="#ccc" height="26" />
        </button>
      </div>
    </div>
  )
}

export default PlaylistEditorTrackThemeModal
